import { targetsWithoutAll } from "@/shared/utils/constant";
import { useState } from "react";
import Textfield from "../Input/Textfield";
import { isGreaterThanZero } from "@/shared/utils/helpers";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Product, Topping } from "@/shared/utils/interfaces";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import TargetOverrideList from "../TargetOverrides/TargetOverrideList";

interface PricePerTargetProps {
  data: Product | Topping;
  pricePerTargetValue?: any;
}

const PricePerTarget = ({ data }: PricePerTargetProps) => {
  const { t } = useTranslation();
  const formContext = useFormContext();
  const { price_per_target_value } = data ?? {};
  const { control, errors } = formContext;
  const defaultTargetIds = Object.keys(price_per_target_value ?? {});
  const { currency } = useCountryConfigHook();

  const [localTargets, setLocalTargets] = useState(
    isGreaterThanZero(defaultTargetIds)
      ? targetsWithoutAll
          .filter((t) => defaultTargetIds.includes(`${t.value}`))
          .map((t) => ({ ...t, price: price_per_target_value[t.value] }))
      : []
  );

  return (
    <TargetOverrideList
      icon="money"
      title={t("menu.pricePerTarget")}
      description={t("targetOverrides.priceHint")}
      targets={localTargets}
      onAdd={(target) =>
        setLocalTargets((prev) => [...prev, { ...target, price: undefined }])
      }
      onRemove={(target) =>
        setLocalTargets((prev) => prev.filter((t) => t.value !== target.value))
      }
      renderControl={(target) => (
        <Controller
          name={`price_per_target_value.#${target.value}`}
          control={control}
          rules={{
            required: { value: true, message: t("fieldRequired") },
          }}
          defaultValue={parseFloat(target.price ?? data?.price ?? "0").toFixed(
            2
          )}
          render={({ onChange, value }) => (
            <Textfield
              type="number"
              onChange={(e) => onChange(e.target.value)}
              defaultValue={value}
              placeholder={t("price")}
              step=".01"
              inputLeftAddon={currency?.symbol}
              leftAddonPadding="0.7rem 1rem"
              error={
                errors?.price_per_target_value?.[`#${target.value}`]?.message
              }
            />
          )}
        />
      )}
    />
  );
};

export default PricePerTarget;
